module.exports = __webpack_public_path__ + "img/scan.b7d7396e.svg";